import React, { useState, useEffect } from 'react';
import { getProductos, getCategorias } from './services';
import AdmProductos from './admProductos';
import AgregarProductos from './cruds/productos/crearProductos';
import ActProductos from './cruds/productos/actProductos';
import './adminStyles.css';

function Admin() {
    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [modalCrear, setModalCrear] = useState(false);
    const [productoParaActualizar, setProductoParaActualizar] = useState(null);

    const cargarProductos = async () => {
        const response = await getProductos();
        if (response.status === 200) {
            const productosOrdenados = response.data.productos.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );
            setProductos(productosOrdenados);
        }
    };

    const cargarCategorias = async () => {
        const response = await getCategorias();
        if (response.status === 200) setCategorias(response.data.categorias);
    };

    useEffect(() => {
        cargarProductos();
        cargarCategorias();
    }, []);

    const handleUpdate = async () => {
        await cargarProductos();
    };

    return (
        <div className="admin-root">
            <AdmProductos
                productos={productos}
                categorias={categorias}
                onProductUpdate={handleUpdate}
                onActualizarProducto={(producto) => setProductoParaActualizar(producto)}
                onAgregarProducto={() => setModalCrear(true)}
            />

            {modalCrear && (
                <div className="admin-modal-overlay" onClick={() => setModalCrear(false)}>
                    <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
                        <AgregarProductos
                            onProductUpdate={handleUpdate}
                            onClose={() => setModalCrear(false)}
                        />
                    </div>
                </div>
            )}

            {productoParaActualizar && (
                <div className="admin-modal-overlay" onClick={() => setProductoParaActualizar(null)}>
                    <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
                        <ActProductos
                            categorias={categorias}
                            onProductUpdate={handleUpdate}
                            productoParaActualizar={productoParaActualizar}
                            onClose={() => { handleUpdate(); setProductoParaActualizar(null); }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default Admin;
